var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDailyUse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.55,211.34c6.36-4.58,2.46-11.13-5.3-13.56h-.07c-14.07.43-27.73,2.87-47.2,1.75-6.22-.35,3.92,8.39,4.37,14.6.28,3.84-.74,7.7,3.43,7.63C241.51,221.5,272.55,211.34,272.55,211.34Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205,173.58s-2.8.54-9.83,3.87c1.85,2,4.22,3.18,7.83,1.47a3.89,3.89,0,0,0,2.13-5C205,173.81,205,173.69,205,173.58Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.91,347.5,384.46,359s-32-6.87-67.73-40.79l.11-.61c-20.52,5-78.82,4.46-88.36-5.86a35.77,35.77,0,0,1-8.9-19.82l32.58-10.64s45.92,4.73,68.27,15.5C343.89,305.7,391.91,347.5,391.91,347.5Z",
    style: {
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "394.02 336.36 396.38 337.5 397.25 337.92 405.28 341.8 406.08 342.19 405.35 351.94 405.32 352.37 404.58 352.14 401.33 351.14 394.52 349.05 393.02 348.59 389.82 347.61 390.44 345.95 394.01 336.37 394.02 336.36",
    style: {
      fill: "#ffc3bd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "401.48 356.11 398.69 365.43 395.23 363.48 385.23 357.82 391.44 348.22 392.91 349.38 394.19 350.38 400.81 355.58 401.48 356.11",
    style: {
      fill: "#ffc3bd"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.46,
    y: 224.38,
    width: 93.08,
    height: 158.04,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.46,
    y: 224.38,
    width: 97.3,
    height: 11.75,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coffee-machine--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "88.94 216.26 55.39 216.26 50.12 183.87 94.22 183.87 88.94 216.26",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.09 184.84 82.44 184.87 80.43 216.22 88.94 216.26 94.09 184.84",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.21,
    y: 159.65,
    width: 64.51,
    height: 25.2,
    rx: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.9,169.72v5c0,5.57-4.48,10-11.06,10H81.29c6.58,0,10-4.46,10-10v-5a10.06,10.06,0,0,0-10-10.13H94.85A10.09,10.09,0,0,1,104.9,169.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.1,
    y: 193.11,
    width: 12.1,
    height: 6.93,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.1,
    y: 193.11,
    width: 7.06,
    height: 6.93,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.42,220.46a4.15,4.15,0,0,1-4.16,4.15H44.07a4.15,4.15,0,0,1-4.16-4.15,4.17,4.17,0,0,1,4.16-4.17h56.19A4.17,4.17,0,0,1,104.42,220.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.53,220.46a4.17,4.17,0,0,1-4.16,4.15H44.07a4.15,4.15,0,0,1-4.16-4.15,4.17,4.17,0,0,1,4.16-4.17h34.3A4.17,4.17,0,0,1,82.53,220.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.47,172.29a6.3,6.3,0,0,1-6.3,6.3,6.06,6.06,0,0,1-1.77-.25,6.3,6.3,0,0,1,0-12.09,6.06,6.06,0,0,1,1.77-.26A6.31,6.31,0,0,1,78.47,172.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.94,172.29a6.3,6.3,0,0,1-4.54,6.05,6.3,6.3,0,0,1,0-12.09A6.3,6.3,0,0,1,74.94,172.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.94,
    y: 184.92,
    width: 20.16,
    height: 8.06,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.94,
    y: 184.92,
    width: 13.99,
    height: 8.06,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.78,
    cy: 172.27,
    r: 2.65,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.85,
    cy: 172.27,
    r: 2.65,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.12,
    cy: 172.27,
    r: 2.65,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.28,
    y: 195.49,
    width: 10.08,
    height: 3.15,
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.12,185.82H62a.95.95,0,0,1,0-1.89h20.1a.95.95,0,1,1,0,1.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.78,175.86a3.59,3.59,0,1,1,3.59-3.59A3.59,3.59,0,0,1,85.78,175.86Zm0-5.29a1.7,1.7,0,1,0,1.7,1.7A1.7,1.7,0,0,0,85.78,170.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.85,175.86a3.59,3.59,0,1,1,3.59-3.59A3.59,3.59,0,0,1,94.85,175.86Zm0-5.29a1.7,1.7,0,1,0,1.7,1.7A1.7,1.7,0,0,0,94.85,170.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.12,175.86a3.59,3.59,0,1,1,3.59-3.59A3.59,3.59,0,0,1,50.12,175.86Zm0-5.29a1.7,1.7,0,1,0,1.7,1.7A1.7,1.7,0,0,0,50.12,170.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.08,170.26a1,1,0,0,1-.94-.95v-3.15a.95.95,0,0,1,1.89,0v3.15A1,1,0,0,1,72.08,170.26Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.5,375.63H45V243.81H122.5Zm-76.51-1H121.5V244.81H46Z",
    style: {
      fill: "#e6e6e6",
      stroke: "#fafafa",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.12,
    y: 293.99,
    width: 5.99,
    height: 18.33,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.05,347.88l-1,.13c-.07-.52-6.23-52.09,6.48-94.23,12.64-41.89,3.94-68.58,3.85-68.84l1-.33c.09.27,8.89,27.27-3.84,69.46C419.85,296,426,347.37,426.05,347.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.18,190.68a16,16,0,0,0-8.56-5.28l.23-1A17.09,17.09,0,0,1,438,190Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.64,
    y: 195.73,
    width: 3.36,
    height: 1.02,
    transform: "translate(-39.58 241.96) rotate(-29.46)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.08,218.72A24.36,24.36,0,0,0,422.92,206l.38-1A25.41,25.41,0,0,1,437,218.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.33,250.94l-1,0A14.07,14.07,0,0,0,427,240.19l.63-.8A15.06,15.06,0,0,1,433.33,250.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.05,259.18l-.95-.37a10.25,10.25,0,0,1,5.82-5.75l.36,1A9.22,9.22,0,0,0,431.05,259.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.42,311.45l-.79-.65c1.25-1.51,2.19-7.22,2.69-10.29.13-.74.23-1.36.31-1.82l1,.2c-.08.44-.19,1.06-.31,1.78C426.58,305.26,425.73,309.87,424.42,311.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.83,327.86a10.08,10.08,0,0,0-9.77-6.74l-.05-1a11.14,11.14,0,0,1,10.79,7.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.02,
    y: 342.41,
    width: 10.82,
    height: 1.02,
    transform: "translate(-112.75 433.9) rotate(-48.22)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.75,285.94c1.63,5.29-9.77,15.36-9.77,15.36s-15.09-1.89-16.72-7.18,2.18-13.94,9.5-16.2S435.11,280.65,436.75,285.94Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.4,221.74c-1.45,5.62-12.24,9.61-12.24,9.61s-7.53-8.71-6.08-14.33,7.41-11.8,12.47-10.5S450.84,216.12,449.4,221.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.08,305.69c6.78,2.64,10.93,14.63,10.93,14.63s-11.17,6-17.94,3.39-14-10.08-12-15S399.3,303.06,406.08,305.69Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.94,239.74a14.47,14.47,0,0,0,4.63,2.61,4.89,4.89,0,0,0,4.94-1.16c1.45-1.67,1.06-4.26.15-6.27-1.81-4-8.49-10.77-13.62-8.83C409.63,228.9,417.64,237.28,420.94,239.74Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.1,249.91c-1,1.2-2,2.72-1.47,4.17a3.11,3.11,0,0,0,3.41,1.68,9.07,9.07,0,0,0,3.67-1.8c2.61-1.81,8-5.62,4.55-9.18C442.7,241.07,438.15,247.37,436.1,249.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.22,199.2a2.69,2.69,0,0,0-2.44,2c-.22,1.3.85,2.43,1.9,3.24,2.59,2,10.4,7.4,12.14,2.19C427.46,201.69,417.67,198.82,414.22,199.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.61,182.06c-1.61.16-3.22-.43-4.83-.33s-3.41,1.41-3,3,2.15,1.95,3.64,2a29.46,29.46,0,0,0,7.61-.52,2.32,2.32,0,0,0,1.54-.78c.65-1-.38-2.25-1.49-2.59s-2.37-.23-3.38-.81Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.34,193.14c1.62.05,3.18-.64,4.8-.64s3.49,1.17,3.24,2.77-2,2.08-3.5,2.27a29,29,0,0,1-7.62,0,2.35,2.35,0,0,1-1.6-.68c-.71-.91.24-2.27,1.33-2.68s2.34-.38,3.31-1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.75,312.25a2.23,2.23,0,0,1,1.38-.67,1.55,1.55,0,0,1,1.37,1.34,4.35,4.35,0,0,1-.26,2c-1.1,3.66-13.4,30.22-16.23,25.45-1.67-2.82,2.44-12.16,3.65-14.8A38.72,38.72,0,0,1,442.75,312.25Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.39,183.07c1-2.19,2-4.48,4-5.89s5-1.52,6.46.42c1.58,2.17,0,5.46-2.42,6.62s-5.26.81-7.92.43l-.06-1.18Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.87,383h0a100.91,100.91,0,0,1-39.56,0h0L394,337.61h60.21Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 415.69,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.89,102.69c0,25.3-23.83,45.79-49.11,45.79q-1.29,0-2.55-.06a45.8,45.8,0,0,1,0-91.46c.84,0,1.69-.07,2.55-.07C346.06,56.89,369.89,77.4,369.89,102.69Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.79,102.69c0,24.44-22.47,44.4-46.56,45.73a45.8,45.8,0,0,1,0-91.46C342.32,58.29,364.79,78.26,364.79,102.69Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.9,102.69c0,20.3-19.78,36.75-40.08,36.75a36.75,36.75,0,0,1,0-73.5C338.12,65.94,357.9,82.39,357.9,102.69Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M353.06,96l-1.81.05c-.11-.21.08-.56.34-.91l.07-.07a8.93,8.93,0,0,1,.92-.93l.06,0-21.45.51.61,1a4,4,0,0,1,.53,1.87l.14,5.93c.09,3.62,4.12,6.48,9,6.37l1.28,0c3.56-.09,6.56-1.74,7.9-4a2.77,2.77,0,0,0,1.11-.51l3.38-2.65a1.84,1.84,0,0,0,.76-1.45l-.08-3.2C355.79,96.8,354.54,95.93,353.06,96Zm1.94,4.79c0,1,0,.93-.92,1.64l-1.7,1.17a.66.66,0,0,1-1-.53c0-1.55,0-4.14-.07-5.5a1.09,1.09,0,0,1,1.18-.9l.75,0c.94,0,1.71.53,1.73,1.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.06,96l-1.81.05c-.11-.21.08-.56.34-.91l.07-.07a8.93,8.93,0,0,1,.92-.93l.06,0-21.45.51.61,1a4,4,0,0,1,.53,1.87l.14,5.93c.09,3.62,4.12,6.48,9,6.37l1.28,0c3.56-.09,6.56-1.74,7.9-4a2.77,2.77,0,0,0,1.11-.51l3.38-2.65a1.84,1.84,0,0,0,.76-1.45l-.08-3.2C355.79,96.8,354.54,95.93,353.06,96Zm1.94,4.79c0,1,0,.93-.92,1.64l-1.7,1.17a.66.66,0,0,1-1-.53c0-1.55,0-4.14-.07-5.5a1.09,1.09,0,0,1,1.18-.9l.75,0c.94,0,1.71.53,1.73,1.22Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M346,87.17c0,1.86-2.25,3.37-5,3.37s-5-1.51-5-3.37,2.25-3.38,5-3.38S346,85.3,346,87.17Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.13,
    cy: 79.63,
    r: 1.88,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.74,107.67a3.87,3.87,0,1,1,0-5.48A3.85,3.85,0,0,1,321.74,107.67Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.68 105.63 317 83.07 318.27 80.76 319.33 83 319.95 103.44 345.6 109.36 347.32 110.4 345.15 111.67 317.68 105.63",
    style: {
      fill: "#3E424F"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.29,389.26S96.73,423.55,268,419C268,419,243.62,385.08,204.29,389.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.46,298.31c-15.39-20.58-49.52-18.77-69.85-35.07-12.09-9.7-17.79-24.58-26.72-37-16.83-23.34-50.09-42.69-81-33.43a54.23,54.23,0,0,0-24.92,16.31c-9.79,11.18-15.06,25.23-18.3,39.3a164.14,164.14,0,0,0,1.64,80.35c5.27,19.05,14.27,37.43,28.6,51.55a110.91,110.91,0,0,0,24.29,17.74h0l.15.09c4.3,2.39,8.75,4.56,13.28,6.57h0c2.3,1,4.61,2,7,2.95,21.28,8.56,44.67,14.2,67.88,11.1a99.18,99.18,0,0,0,69.4-44.11,101.67,101.67,0,0,0,14.1-33.44c.36-1.65.69-3.31,1-5C356.11,323.19,355.43,309,347.46,298.31Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.93,341.26a101.67,101.67,0,0,1-14.1,33.44c-3.46-1.48-10.28-32-44.66-35.56-1.42-.15-19.27-1.71-19.68-2.79,3.77-3.21,30.91-8.35,35.54-10.53,18.57-8.77,35.8,4.74,41,12.23A28.07,28.07,0,0,1,352.93,341.26Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.74,199.7c-19.19.24-34.5,16.27-34.7,35.46-.36,34,1.15,89.78,30.59,103.49,48.69,22.67,165.31-3.55,155.24-29.3s-71.56-7.8-87.35-43.72C237.68,238.69,216.46,199.32,185.74,199.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.62,263.76h0a5.82,5.82,0,0,1,7.55,1.33c6,7.34,7.28,18.44,2.57,26.74,13.11-3.11,18.58,21.14,11.63,31,4.5-6.75,6.27-16.07,2.55-23.28-6.15-11.94-2.78-18.36-2.78-18.36-4.56-.82-6.54-5.2-9-10.67s-7.28-8.4-3.6-14.85a14,14,0,0,1-9-8.37c-2.6-6.6-2-10.58-5.43-8.94C154.07,238.33,164.22,258.4,159.62,263.76Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.56,250.06h0a5.83,5.83,0,0,1,7.58,1.2c6.09,7.23,7.6,18.32,3,26.69,13.06-3.34,19,20.82,12.17,30.76,4.39-6.83,6-16.17,2.15-23.32-6.35-11.83-1.21-15-1.21-15-4.57-.74-8.52-8.38-11.07-13.81s-7.43-8.26-3.87-14.78a14,14,0,0,1-9.18-8.21c-2.72-6.55-2.21-10.55-5.58-8.85C171.58,224.73,182.07,244.62,177.56,250.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.65,317.54c-7.32,5.8-14.64,13.14-15.33,22.45a214.56,214.56,0,0,1,87.28-53c-5.51-2-11.15.24-16.53,1.63A126.42,126.42,0,0,0,237.3,296,168.07,168.07,0,0,0,201.65,317.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,329.5a10,10,0,0,0,1.83,6.09c.82,1.15,2.2,2.21,3.55,1.79s1.9-2.16,2.14-3.62a15.43,15.43,0,0,0,.24-5,5.73,5.73,0,0,0-2.62-4.12,3.58,3.58,0,0,0-4.54.79c-.81,1.14-.69,2.67-.54,4.07",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.36,379.38c6.31,1.2,12.81,2.11,19.16,1.08,2.15-.35-4.25-2.71-8.16-3.69-18-4.54-43.57-10.88-69.47-36.84-6.19-6.21-3.33,5.55-1.07,8.44,8.9,11.39,22,19.13,35.33,24.25A142.78,142.78,0,0,0,221.36,379.38Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.59,332.85c7.13,5.17,16.11,8.27,24.62,6-7.16-3.81-12.13-10.82-15.42-18.24s-5.16-15.37-7.75-23.05a126.23,126.23,0,0,0-26.69-45c-1.27-1.37-11.08-24.67-12.93-24.92-2.12-.28-6.29,12.32-.18,24.57,0,0,5.07-.32,8.75,13.16,2.95,10.78.19,14.06.19,14.06,1.11,2.19,3.36-4.14,10.12,10.87,6.11,13.58,4.2,30,4.2,30C196.45,330.57,201.53,329.18,206.59,332.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.21,291a.54.54,0,0,1-.54-.2,35.7,35.7,0,0,0-6.58-6.72.52.52,0,0,1-.08-.73.51.51,0,0,1,.73-.08,37.14,37.14,0,0,1,6.77,6.91.53.53,0,0,1-.11.73A.66.66,0,0,1,353.21,291Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.48,280.16a.56.56,0,0,1-.38-.05c-7.35-4.19-16.19-7-24.74-9.65-11.49-3.6-23.37-7.32-32.44-14.6a.51.51,0,0,1-.08-.73.52.52,0,0,1,.73-.08c8.92,7.15,20.7,10.85,32.1,14.42,8.6,2.7,17.5,5.49,24.95,9.73a.52.52,0,0,1-.14,1Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.55,211.34c6.36-4.58,2.46-11.13-5.3-13.56h-.07c-14.07.43-27.73,2.87-47.2,1.75-6.22-.35,3.92,8.39,4.37,14.6.28,3.84-.74,7.7,3.43,7.63C241.51,221.5,272.55,211.34,272.55,211.34Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.55,211.34c6.36-4.58,2.46-11.13-5.3-13.56h-.07c-14.07.43-27.73,2.87-47.2,1.75-6.22-.35,3.92,8.39,4.37,14.6.28,3.84-.74,7.7,3.43,7.63C241.51,221.5,272.55,211.34,272.55,211.34Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.42,215.31c1.33.27,33.88-.5,37.78-1.69s-24,8.67-37.42,8.13S227.42,215.31,227.42,215.31Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.07,279.91h0a99.26,99.26,0,0,1-29.92,9.78l-22.47,3.56c-1.53-4.44-7.13-13.69-17.47-38.43-4-12.73-8.56-16-8.67-36.58l0-.11a6.33,6.33,0,0,1,3.7-8.29l.11,0c3.16-1.27,7.15-2.77,11.13-4a223.46,223.46,0,0,1,23.06-5.8,67.55,67.55,0,0,1,7.91-.7,10,10,0,0,1,9.07,4.47C234.41,213.43,243.91,233.2,252.07,279.91Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.07,279.91h0a99.26,99.26,0,0,1-29.92,9.78l-22.47,3.56c-1.53-4.44-7.13-13.69-17.47-38.43-4-12.73-8.56-16-8.67-36.58l0-.11a6.33,6.33,0,0,1,3.7-8.29l.11,0c3.16-1.27,7.15-2.77,11.13-4a223.46,223.46,0,0,1,23.06-5.8,67.55,67.55,0,0,1,7.91-.7,10,10,0,0,1,9.07,4.47C234.41,213.43,243.91,233.2,252.07,279.91Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192.93,270.84c-.54-.14.09,4.71,7.43,8.05s39.49-14,42.35-20.67C242.71,258.22,210.34,275.38,192.93,270.84Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.29,262.36c-3.82-11.82-8.7-23.57-12.43-32.07a2.72,2.72,0,0,1,.19-.47c1.27-2.92,5.24-1.74,10.21,4.21a40.22,40.22,0,0,1,5.16,8.11c2.39,4.86,7.77,14.49,7.89,16.29C204.82,265.91,199.09,269.21,193.29,262.36Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.82,208.34c-11.26,3.5-17.14-2.31-17.14-2.31,3.75-6.27-1.58-19.31-5.15-26.32l7.45,3.57,10.16,4.86a30.2,30.2,0,0,0,.32,3.55,14.22,14.22,0,0,0,.57,2.48v0l.05.14c1.14,3.38,3.7,5.84,9.39,5.76C210.47,200.1,214.42,205.32,204.82,208.34Z",
    style: {
      fill: "#f7978d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.14,188.14a30.2,30.2,0,0,0,.32,3.55,14.22,14.22,0,0,0,.57,2.48v0l.05.14c-3.3.13-8.26-2.13-9.53-5.23a14.83,14.83,0,0,1-.93-3.15Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.13,205.77l3.19-2.19a35.82,35.82,0,0,0,15.74,4.95,13.88,13.88,0,0,0-3.41,7.31C187.44,214.77,185.13,205.77,185.13,205.77Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.27,199.47l-3.45.14s.39,7.16-2.75,9c6.47.81,8.18,3.47,8.18,3.47C220,207.18,210.27,199.47,210.27,199.47Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.13,205.77l3.19-2.19a35.82,35.82,0,0,0,15.74,4.95,13.88,13.88,0,0,0-3.41,7.31C187.44,214.77,185.13,205.77,185.13,205.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.27,199.47l-3.45.14s.39,7.16-2.75,9c6.47.81,8.18,3.47,8.18,3.47C220,207.18,210.27,199.47,210.27,199.47Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.53,170.66s4.46,2.74,6-2.85c-4.39-3.42-3-4.66-4.54-8.08a12,12,0,0,0-9.62-7.76l-3.44,1.8C175.67,162.34,198.53,170.66,198.53,170.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.16,169.89a13.7,13.7,0,0,1,10.34-16.38c10.71-2.7,21.38,8.55,25.32,17.2a13.52,13.52,0,0,1-14.3,19.21c-7.53-1.1-11.17-6-18.08-13.77A13.72,13.72,0,0,1,173.16,169.89Z",
    style: {
      fill: "#f7978d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,173.58s-2.8.54-9.83,3.87c1.85,2,4.22,3.18,7.83,1.47a3.89,3.89,0,0,0,2.13-5C205,173.81,205,173.69,205,173.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.58,177.94a6.63,6.63,0,0,1,4.44-.7,4.14,4.14,0,0,1-2,1.78,6.59,6.59,0,0,1-4.43.69A4,4,0,0,1,200.58,177.94Z",
    style: {
      fill: "#ff5652"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204.6,173.67a1.74,1.74,0,0,1-.59,1.69,37.62,37.62,0,0,1-6.5,2.34,2.13,2.13,0,0,1-2.09-.42A56.8,56.8,0,0,1,204.6,173.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.6,186.46s-.52-11.08-2.32-13.85a9.89,9.89,0,0,0-9.87-5l-3,2.4C158.69,183.44,185.6,186.46,185.6,186.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.35,172A4.79,4.79,0,0,0,204.1,169a31.3,31.3,0,0,1-7.71-3.3Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.62,178.3c2.11-1.52,6,.09,8.07,1.69,2.27,1.79,2.62,4.37-.1,5a9.72,9.72,0,0,1-6.5-1C176.58,182.74,175.51,179.82,177.62,178.3Z",
    style: {
      fill: "#f7978d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,168.27c.45-.32,1.28,0,1.75.62s.53,1.41.09,1.74-1.18,0-1.75-.61S190.56,168.59,191,168.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.37,162.27c.45-.32,1.23-.05,1.75.62s.59,1.48.14,1.8-1.24,0-1.76-.63S197.92,162.6,198.37,162.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.1,160.33a.52.52,0,0,0,.46-.11A4.19,4.19,0,0,1,199,159a.48.48,0,0,0,.58-.36v0a.5.5,0,0,0-.38-.59h0a5.14,5.14,0,0,0-4.34,1.45.5.5,0,0,0,0,.7A.58.58,0,0,0,195.1,160.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.89,168.46a.54.54,0,0,0,.3-.36,4.2,4.2,0,0,1,2-3.08.48.48,0,0,0,.24-.64v0a.51.51,0,0,0-.66-.23h0a5.13,5.13,0,0,0-2.53,3.81.5.5,0,0,0,.42.56A.57.57,0,0,0,187.89,168.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.09,155.44c-.48-1.13-.77-3.91-2.13-5.35a7,7,0,0,0-5.33-2.17c-2.94.12-5.46,2.05-7.76,3.9a5.9,5.9,0,0,0-1.46,1.49,2,2,0,0,0-.13,2,2,2,0,0,0,1.82.86c.7,0,5.82-1.22,8.08-1.46C189.13,154.59,193.11,154.31,195.09,155.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.22,164.75c-2.07,4.3-.14,10.61,3.37,13.55a49.4,49.4,0,0,0,4.48,3.09l4.11-7.39a15.08,15.08,0,0,0,2.75-10.12,8.12,8.12,0,0,1,.43-3.28,8.45,8.45,0,0,1,5.62-5.25c1-.26,2.25-.66,2.2-1.66s-2.09-2-3.46-2.34C178.34,149.87,170.57,151.52,164.22,164.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.91,163.32c.31-5.18,3.08-7,7.28-8.38a4,4,0,0,0-2.47-1.8C179.27,152.1,178,160.13,178.91,163.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.5,153.46a3.17,3.17,0,0,1,1.23.85,9.74,9.74,0,0,1,2.33,7.18,10.27,10.27,0,0,0,.14-5,9.31,9.31,0,0,0-.92-3,4.13,4.13,0,0,0-2.33-2,2.72,2.72,0,0,0-2.87.8c-.39.52-.76,1.89.09,2S186.32,153.06,187.5,153.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.31,224.39c.5,1.29,1.16,2.87,1.77,4.35l1.9,4.48c1.32,3,2.64,5.9,4.06,8.78s2.9,5.67,4.51,8.29a54.06,54.06,0,0,0,5,7.24c.81,1,4.35-1.77,16.61-1.59a31.93,31.93,0,0,0,8.36-1.21c1.51-.4,3-.87,4.45-1.39l2.19-.82,2.08-.84,4.95,6.75c-.81.75-1.48,1.31-2.19,2a20.84,20.84,0,0,1-2.21,1.79,47.16,47.16,0,0,1-4.8,3.08c-3.51,2-29,13.59-35.59,9.94-6.56-5-14.91-18.66-18.33-25.39-1.71-3.25-3.27-6.45-4.7-9.68-.73-1.69-1.39-3.27-2.06-4.95-.12-.3-.36-.9-.69-1.7-3.24-8.1-4.15-17.5,3.49-22.69l5.2-2Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.31,224.39c.5,1.29,1.16,2.87,1.77,4.35l1.9,4.48c1.32,3,2.64,5.9,4.06,8.78s2.9,5.67,4.51,8.29a54.06,54.06,0,0,0,5,7.24c.81,1,4.35-1.77,16.61-1.59a31.93,31.93,0,0,0,8.36-1.21c1.51-.4,3-.87,4.45-1.39l2.19-.82,2.08-.84,4.95,6.75c-.81.75-1.48,1.31-2.19,2a20.84,20.84,0,0,1-2.21,1.79,47.16,47.16,0,0,1-4.8,3.08c-3.51,2-29,13.59-35.59,9.94-6.56-5-14.91-18.66-18.33-25.39-1.71-3.25-3.27-6.45-4.7-9.68-.73-1.69-1.39-3.27-2.06-4.95-.12-.3-.36-.9-.69-1.7-3.24-8.1-4.15-17.5,3.49-22.69l5.2-2Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,248.9c1.12.61,2.76.79,3.6-.16,1.57-1.61,2.75-3.94,2.13-6.14-2.44-3-4.14,2.05-5.51,3.27C243.34,246.66,242.74,248.23,244,248.9Z",
    style: {
      fill: "#f7978d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.59,245.17a6,6,0,0,0,.55,1.34,11.81,11.81,0,0,0,1.12,1.78,9.6,9.6,0,0,0,2.07,1.85l.53.32a10,10,0,0,0,1.48.8,8.53,8.53,0,0,0,3.12.85.65.65,0,0,1,.52.29c.16.23.36.44.54.66s.31.38.44.58a1.51,1.51,0,0,0,.76.65,5.29,5.29,0,0,0,1.91.35,19.21,19.21,0,0,0,5.07-.47,24.59,24.59,0,0,0,2.56-.65,19.52,19.52,0,0,0,2.65-1.06,8.16,8.16,0,0,0,1.91-1.22,1.61,1.61,0,0,0,.51-.77c0-.17,0-.33.09-.49.11-.48.22-.95.32-1.42.17-.73.27-1.46.37-2.2s.21-1.44.24-2.15.06-1.47,0-2.22c0-1.24-.08-2.49-.16-3.74,0-.58-.16-1.24-.23-1.83a4.74,4.74,0,0,0-.38-1.37,2.14,2.14,0,0,0-.63-.77,6.8,6.8,0,0,0-2.53-1.1,10.9,10.9,0,0,0-2.61-.25c-.37,0-.73,0-1.1,0a26.89,26.89,0,0,0-11.1,2.72,15.52,15.52,0,0,0-2,1.15,8.54,8.54,0,0,0-1.5,1.38,3.6,3.6,0,0,0-.77,1.31,2.26,2.26,0,0,0-.09.58c0,.23,0,.24-.24.24a3.38,3.38,0,0,0-3.06,1.55,3.46,3.46,0,0,0-.47,1.41A4.56,4.56,0,0,0,248.59,245.17Zm8.78-4.41a10.4,10.4,0,0,1-2.3-.26,1.28,1.28,0,0,1-.54-.18,3,3,0,0,1,.75-1.28,6.5,6.5,0,0,1,.75-.64,10.41,10.41,0,0,1,1.46-.9,22.86,22.86,0,0,1,2.44-1,25.14,25.14,0,0,1,2.43-.72c.76-.2,1.39-.3,2.17-.44a24.55,24.55,0,0,1,3-.29,13.77,13.77,0,0,1,3,.18,5,5,0,0,1,2.32,1s0,0-.05.07l-.18.19a4.79,4.79,0,0,1-.55.46,11.34,11.34,0,0,1-2.34,1.34c-.19.09-.38.18-.57.25l-.32.13c-.62.26-1.26.47-1.89.67s-1.24.37-1.88.51l-1.46.35a.21.21,0,0,1-.11,0s0,0,0,0l-.27.07c-.65.11-1.31.21-2,.3s-1.16.17-1.76.22S258.05,240.77,257.37,240.76Zm-5.87,3.31a1.42,1.42,0,0,1,.94-1.31l.41-.12c.33.93.72,1.79,1.08,2.66.46,1.16,1,2.26,1.58,3.36a6.54,6.54,0,0,0,1,1.5l-.77-.41a10,10,0,0,1-2-1.61,9.69,9.69,0,0,1-1.69-2.08A3.46,3.46,0,0,1,251.5,244.07Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.59,245.17a6,6,0,0,0,.55,1.34,11.81,11.81,0,0,0,1.12,1.78,9.6,9.6,0,0,0,2.07,1.85l.53.32a10,10,0,0,0,1.48.8,8.53,8.53,0,0,0,3.12.85.65.65,0,0,1,.52.29c.16.23.36.44.54.66s.31.38.44.58a1.51,1.51,0,0,0,.76.65,5.29,5.29,0,0,0,1.91.35,19.21,19.21,0,0,0,5.07-.47,24.59,24.59,0,0,0,2.56-.65,19.52,19.52,0,0,0,2.65-1.06,8.16,8.16,0,0,0,1.91-1.22,1.61,1.61,0,0,0,.51-.77c0-.17,0-.33.09-.49.11-.48.22-.95.32-1.42.17-.73.27-1.46.37-2.2s.21-1.44.24-2.15.06-1.47,0-2.22c0-1.24-.08-2.49-.16-3.74,0-.58-.16-1.24-.23-1.83a4.74,4.74,0,0,0-.38-1.37,2.14,2.14,0,0,0-.63-.77,6.8,6.8,0,0,0-2.53-1.1,10.9,10.9,0,0,0-2.61-.25c-.37,0-.73,0-1.1,0a26.89,26.89,0,0,0-11.1,2.72,15.52,15.52,0,0,0-2,1.15,8.54,8.54,0,0,0-1.5,1.38,3.6,3.6,0,0,0-.77,1.31,2.26,2.26,0,0,0-.09.58c0,.23,0,.24-.24.24a3.38,3.38,0,0,0-3.06,1.55,3.46,3.46,0,0,0-.47,1.41A4.56,4.56,0,0,0,248.59,245.17Zm8.78-4.41a10.4,10.4,0,0,1-2.3-.26,1.28,1.28,0,0,1-.54-.18,3,3,0,0,1,.75-1.28,6.5,6.5,0,0,1,.75-.64,10.41,10.41,0,0,1,1.46-.9,22.86,22.86,0,0,1,2.44-1,25.14,25.14,0,0,1,2.43-.72c.76-.2,1.39-.3,2.17-.44a24.55,24.55,0,0,1,3-.29,13.77,13.77,0,0,1,3,.18,5,5,0,0,1,2.32,1s0,0-.05.07l-.18.19a4.79,4.79,0,0,1-.55.46,11.34,11.34,0,0,1-2.34,1.34c-.19.09-.38.18-.57.25l-.32.13c-.62.26-1.26.47-1.89.67s-1.24.37-1.88.51l-1.46.35a.21.21,0,0,1-.11,0s0,0,0,0l-.27.07c-.65.11-1.31.21-2,.3s-1.16.17-1.76.22S258.05,240.77,257.37,240.76Zm-5.87,3.31a1.42,1.42,0,0,1,.94-1.31l.41-.12c.33.93.72,1.79,1.08,2.66.46,1.16,1,2.26,1.58,3.36a6.54,6.54,0,0,0,1,1.5l-.77-.41a10,10,0,0,1-2-1.61,9.69,9.69,0,0,1-1.69-2.08A3.46,3.46,0,0,1,251.5,244.07Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,241c1.68,1,5,1.05,10.29-.14s8.24-2.69,9.35-4.29a2.15,2.15,0,0,0-.75-2.89,7.67,7.67,0,0,0-1.38-.45,10.9,10.9,0,0,0-2.61-.25c-.37,0-.73,0-1.1,0a26.75,26.75,0,0,0-11.09,2.73,14.34,14.34,0,0,0-2,1.14,8.84,8.84,0,0,0-.94.78h0A2.16,2.16,0,0,0,254,241Zm.57-.63a3,3,0,0,1,.75-1.27,7.65,7.65,0,0,1,.74-.65,10,10,0,0,1,1.47-.9,19.19,19.19,0,0,1,2.43-1c.82-.29,1.59-.52,2.43-.73s1.39-.3,2.18-.43a24.37,24.37,0,0,1,3-.3,13.81,13.81,0,0,1,3,.19,4.93,4.93,0,0,1,2.32,1s0,0-.05.06a1.8,1.8,0,0,1-.19.2,4.6,4.6,0,0,1-.53.46,12.18,12.18,0,0,1-2.35,1.34l-.58.25-.32.13a19.9,19.9,0,0,1-1.88.66c-.62.2-1.24.37-1.88.51-.49.11-1,.25-1.47.35l-.1,0h-.05l-.23.05h-.05c-.65.12-1.3.21-2,.3s-1.17.17-1.76.22-1.37,0-2,0a11.11,11.11,0,0,1-2.3-.26A1.4,1.4,0,0,1,254.52,240.32Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.55,240.31a3,3,0,0,1,.75-1.27,6.41,6.41,0,0,1,.74-.64,8.51,8.51,0,0,1,1.47-.9,20.83,20.83,0,0,1,2.43-1c.82-.29,1.6-.51,2.43-.72s1.39-.31,2.18-.44a26.74,26.74,0,0,1,3-.3,13.76,13.76,0,0,1,3,.19,4.93,4.93,0,0,1,2.32,1l-.05.06a1.8,1.8,0,0,1-.19.2,4.6,4.6,0,0,1-.53.46,11.89,11.89,0,0,1-2.35,1.34l-.58.25-.31.13c-.62.25-1.25.47-1.89.67s-1.24.37-1.88.51-1,.24-1.47.34l-.1,0h-.05l-.23.05h-.05c-.65.12-1.3.22-2,.31s-1.17.17-1.75.21a20.2,20.2,0,0,1-2.06,0,11.18,11.18,0,0,1-2.3-.26A1.4,1.4,0,0,1,254.55,240.31Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.55,240.31a3,3,0,0,1,.75-1.27,6.41,6.41,0,0,1,.74-.64,8.51,8.51,0,0,1,1.47-.9,20.83,20.83,0,0,1,2.43-1c.82-.29,1.6-.51,2.43-.72s1.39-.31,2.18-.44a26.74,26.74,0,0,1,3-.3,13.76,13.76,0,0,1,3,.19,4.93,4.93,0,0,1,2.32,1l-.05.06a1.8,1.8,0,0,1-.19.2,4.6,4.6,0,0,1-.53.46,11.89,11.89,0,0,1-2.35,1.34l-.58.25-.31.13c-.62.25-1.25.47-1.89.67s-1.24.37-1.88.51-1,.24-1.47.34l-.1,0h-.05l-.23.05h-.05c-.65.12-1.3.22-2,.31s-1.17.17-1.75.21a20.2,20.2,0,0,1-2.06,0,11.18,11.18,0,0,1-2.3-.26A1.4,1.4,0,0,1,254.55,240.31Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.53,240.32a1.28,1.28,0,0,0,.54.18,10.4,10.4,0,0,0,2.3.26c.68,0,1.37,0,2,0s1.18-.13,1.76-.22,1.32-.19,2-.3l.27-.07s0,0,0,0a.21.21,0,0,0,.11,0l1.46-.35c.64-.14,1.27-.32,1.88-.51s1.27-.41,1.89-.67l.32-.13c.19-.07.38-.16.57-.25a11.34,11.34,0,0,0,2.34-1.34,4.79,4.79,0,0,0,.55-.46l.18-.19s0,0,.05-.07a5,5,0,0,0-2.32-1,13.77,13.77,0,0,0-3-.18,24.55,24.55,0,0,0-3,.29c-.78.14-1.41.24-2.17.44a25.14,25.14,0,0,0-2.43.72,22.86,22.86,0,0,0-2.44,1,10.41,10.41,0,0,0-1.46.9,6.5,6.5,0,0,0-.75.64A3,3,0,0,0,254.53,240.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.19,238.68a4.05,4.05,0,0,1,.48-.66c.74-.83,2.47-2.18,6.24-3.42a19.79,19.79,0,0,1,3.95-.88,15.7,15.7,0,0,1,6.9.44,4.2,4.2,0,0,1,.72.4,1.2,1.2,0,0,1,.38,1.57,2.41,2.41,0,0,1-.21.24h0c-2.38-1.65-7.74-.84-9.49-.51s-6.91,2-8.35,4.54h0a1.23,1.23,0,0,1-.29-.13A1.2,1.2,0,0,1,254.19,238.68Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.81,245s2,4.65,1.51,5.21l-2.22,2.53s-5,4.95-10.2,5.88a4.41,4.41,0,0,1-4.54-2.19l-.45-.8a5.73,5.73,0,0,1-.48-1.14c-.62-2.19.08-3.47,1.87-4.84l5.12-4.12a3,3,0,0,1,1.6-.6l6.16-1.79C253,243.1,253.36,243.69,253.81,245Z",
    style: {
      fill: "#f7978d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.19,252.52a7.17,7.17,0,0,1,2.72,3.11c1,2.12,2.12,4.77,2.12,4.77l2.19-2s-.69-3.76-2.58-5.65l-1.89-1.89A12.62,12.62,0,0,1,235.19,252.52Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.19,252.52a7.17,7.17,0,0,1,2.72,3.11c1,2.12,2.12,4.77,2.12,4.77l2.19-2s-.69-3.76-2.58-5.65l-1.89-1.89A12.62,12.62,0,0,1,235.19,252.52Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.54,169.88a2.12,2.12,0,0,0-.09-2.5,4.62,4.62,0,0,0-4.26-1.51c-2.08,1.69,1.41,2.89,2.25,3.85C231,170.31,232.07,170.73,232.54,169.88Z",
    style: {
      fill: "#f7978d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.32,165.44c-5,1.89-8,6.16-6.69,9.55s6.36,4.6,11.33,2.72,8-6.16,6.7-9.55S222.31,163.56,217.32,165.44Zm1.78,5.22c-1.52.57-2.92.6-3.13.06s.86-1.45,2.38-2,2.93-.6,3.14-.06S220.62,170.08,219.1,170.66Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.24,176.09c.27-.19.27-.6.47-.87a1,1,0,0,1,1.17-.2,12.1,12.1,0,0,1,1.08.67,2.78,2.78,0,0,0,3.65-1.07A2.56,2.56,0,0,1,219,174c.5-.51,1.35-.24,2.07-.18A3.16,3.16,0,0,0,224,172.2a3.09,3.09,0,0,1,.57-.92c.6-.51,1.53-.21,2.26-.48a2.48,2.48,0,0,0,1.37-1.86c.1-.41.16-.83.24-1.24-1.56-3-6.37-4-11.12-2.26-4.06,1.54-6.81,4.68-7,7.62a1.73,1.73,0,0,1,.16-.3,1.73,1.73,0,0,0-.16.3,4.7,4.7,0,0,0,.28,1.93,5,5,0,0,0,.49.91,2,2,0,0,0,.37.21A.82.82,0,0,0,212.24,176.09Zm6.11-7.4c1.53-.58,2.93-.6,3.14-.06s-.87,1.45-2.39,2-2.92.6-3.13.06S216.83,169.27,218.35,168.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.2,167.06l0,.05a21.82,21.82,0,0,1-4.7.18,3.24,3.24,0,0,0-3.55,3.19v.67a4.11,4.11,0,0,0,2.72,3.74l9.1,1.83,6.32.25,2.34-5.05Z",
    style: {
      fill: "#f7978d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.22,194.93l2.89,4.74a19.87,19.87,0,0,0,9.21,8h0a9.32,9.32,0,0,0,4.66-.86C274.73,205.73,256.22,194.93,256.22,194.93Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.34,177.93S262.27,213.3,270,211.47c7.41-1.76,15.43-9-29.55-41.38Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.34,177.93S262.27,213.3,270,211.47c7.41-1.76,15.43-9-29.55-41.38Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.5,178.36a8.57,8.57,0,0,1,2-4.56,8.21,8.21,0,0,1,.58-.6,4.5,4.5,0,0,1,.73-.78,3.75,3.75,0,0,1,.86-.53l.16-.15-2.43-1.63a17.28,17.28,0,0,0-4.38,5.45,8.29,8.29,0,0,0-.46,2.85c.51,0,1-.12,1.51-.15A8.29,8.29,0,0,1,238.5,178.36Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.5,178.36a8.57,8.57,0,0,1,2-4.56,8.21,8.21,0,0,1,.58-.6,4.5,4.5,0,0,1,.73-.78,3.75,3.75,0,0,1,.86-.53l.16-.15-2.43-1.63a17.28,17.28,0,0,0-4.38,5.45,8.29,8.29,0,0,0-.46,2.85c.51,0,1-.12,1.51-.15A8.29,8.29,0,0,1,238.5,178.36Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.23 357.82 388.15 359.47 394.19 350.38 391.44 348.22 385.23 357.82",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.91,347.5,384.46,359s-32-6.87-67.73-40.79l.11-.61c-20.52,5-78.82,4.46-88.36-5.86a35.77,35.77,0,0,1-8.9-19.82l32.58-10.64s45.92,4.73,68.27,15.5C343.89,305.7,391.91,347.5,391.91,347.5Z",
    style: {
      fill: "#3E424F"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.91,347.5,384.46,359s-32-6.87-67.73-40.79l.11-.61c-20.52,5-78.82,4.46-88.36-5.86a35.77,35.77,0,0,1-8.9-19.82l32.58-10.64s45.92,4.73,68.27,15.5C343.89,305.7,391.91,347.5,391.91,347.5Z",
    style: {
      fill: "#3E424F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M391.91,347.5,384.46,359s-32-6.87-67.73-40.79l.11-.61c-20.52,5-78.82,4.46-88.36-5.86a35.77,35.77,0,0,1-8.9-19.82l32.58-10.64s45.92,4.73,68.27,15.5C343.89,305.7,391.91,347.5,391.91,347.5Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322,323.05a187.65,187.65,0,0,0,32.43,18.06,291.46,291.46,0,0,0,34.1,11.68l3.42-5.29S303.56,308.57,322,323.05Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M199.5,292.77s.78,20.9,8.24,30.47l50.88-26.59-.48-1.65a12,12,0,0,1,3.8-12.48h0c-3.58-.48-7.49-.38-10.3-3.26h0S242,287.91,199.5,292.77Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.5,292.77s.78,20.9,8.24,30.47l50.88-26.59-.48-1.65a12,12,0,0,1,3.8-12.48h0c-3.58-.48-7.49-.38-10.3-3.26h0S242,287.91,199.5,292.77Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "394.02 336.36 396.38 337.5 397.25 337.92 405.28 341.8 406.08 342.19 405.35 351.94 405.32 352.37 404.58 352.14 401.33 351.14 394.52 349.05 393.02 348.59 389.82 347.61 390.44 345.95 394.01 336.37 394.02 336.36",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "396.22 337.57 392.03 348.59 391.81 349.16 388.4 348.06 389.05 346.26 392.77 335.86 395.29 337.11 396.22 337.57",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M424,333.65,422.79,336h0l0,0,0,.1c-.19.33-.64,1.2-1.24,2.33l-.56,1c-.29.54-.59,1.13-.92,1.73-.22.42-.43.82-.65,1.21-.47.89-.9,1.73-1.31,2.53-2.59,5.12-3.33,7.18-5.31,11.27a2,2,0,0,1-2.67.92L403,353l-1.33-.79h0a.8.8,0,0,1-.27-1.1l4-9.33a13,13,0,0,1,3.09-2.79c3.66-1.81,6.59-2.53,12.42-10C422.08,327.38,426.2,329.3,424,333.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,353s14.66-7.25,16.4-10.53c-.47.89-.9,1.73-1.31,2.53-2.59,5.12-3.33,7.18-5.31,11.27a2,2,0,0,1-2.67.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.33,335.52l-.31.84h0L390.44,346l-.62,1.66-.52,1.4-3.48-1.1-20.71-6.57c-15-2.69-43.15-18.29-43.15-18.29-19.91,9.73-91.08,21.11-103.18,12.69a37.52,37.52,0,0,1-13.59-18.31L219,310a127.21,127.21,0,0,1,60.27-15c15.65,0,33.29.79,44.95,3.54C350.25,302.38,394.33,335.52,394.33,335.52Z",
    style: {
      fill: "#3E424F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "401.48 356.11 398.69 365.43 395.23 363.48 385.23 357.82 391.44 348.22 392.91 349.38 394.19 350.38 400.81 355.58 401.48 356.11",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "392.49 349.03 390.35 347.41 384.6 356.16 383.6 357.68 386.61 359.33 386.94 358.86 393.27 349.63 392.49 349.03",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M419.91,351.84c-2.93,3.6-5.76,6.76-7.88,9.36-3.46,4.24-4.58,6-7.25,9.39a1.93,1.93,0,0,1-2.68.32l-6.83-6.36h0a.75.75,0,0,1,0-1.06v0l5.57-7.88a12.44,12.44,0,0,1,3.46-1.95c3.78-.95,6.65-1,13.6-6.74a1.82,1.82,0,0,1,2.43.34C421.19,348.13,421.55,349.83,419.91,351.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.33,335.52l-.31.84h0L390.44,346l-.62,1.66-.52,1.4-3.48-1.1-20.71-6.57c-15-2.69-43.15-18.29-43.15-18.29-19.91,9.73-91.08,21.11-103.18,12.69-6.41-4.67-11.45-7.17-15.61-21.58h0A105.68,105.68,0,0,1,262.23,295c5.69-.08,11.39,0,17,0,15.65,0,33.29.79,44.95,3.54C350.25,302.38,394.33,335.52,394.33,335.52Z",
    style: {
      fill: "#3E424F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M394.33,335.52l-.31.84h0L390.44,346l-.62,1.66-.52,1.4-3.48-1.1-20.71-6.57c-15-2.69-43.15-18.29-43.15-18.29-19.91,9.73-91.08,21.11-103.18,12.69-6.41-4.67-11.45-7.17-15.61-21.58h0A105.68,105.68,0,0,1,262.23,295c5.69-.08,11.39,0,17,0,15.65,0,33.29.79,44.95,3.54C350.25,302.38,394.33,335.52,394.33,335.52Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M257.82,289.81s-2.9,5.84-21.56,8.85,21.38-2.36,41.53-3.71C277.79,295,262.62,293.32,257.82,289.81Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.6,174.11c-6.25-7.12-15.81-7.41-24.42-7.17-3.13.1-6.42.27-9.11,2.18s-4.47,6.23-3,9.56,5.57,5.41,4.68,8.95c-7.21,4.08-15.64,2.8-23.49,4.48a35.08,35.08,0,0,0-17.06,9.4,9,9,0,0,0-3,4.94c-.49,3.45,2,6.05,4.71,7.82a.83.83,0,0,1-.13,1.4,15,15,0,0,0-5.26,3l0,0c-.95.9-.33,2.76.87,2.68l.45,0c3.26,0,5.92,2.09,5.94,4.73s-2.63,4.79-5.89,4.82c-.81,0-.26,1.21.88,1.55a14.55,14.55,0,0,0,7-.08c2.75-.54,5.72-1.42,7.43-4.07s1-7.53-1.73-8.12A81.28,81.28,0,0,0,294,217.53c2.38-.64,5-1.6,6.28-4.11s0-6.76-2.48-6.43c7.18-2.67,14.67-3.94,21.89-6.37s14.42-6.25,19.46-12.93a11.41,11.41,0,0,0,2.43-5.1C342.1,179.43,340.54,176.3,338.6,174.11Z",
    style: {
      fill: "#d4d6d7"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyUse);
export default __webpack_public_path__ + "static/media/Daily-Use.889f88159c5a64418cf4c102959bf6b3.svg";
export { ForwardRef as ReactComponent };